import { createSTC } from '@lib/web3/contracts/STC';
import createContractHook from '@lib/web3/hooks/contracts/createContractHook';

const useSTC = createContractHook(createSTC);
export default useSTC;
